import Swiper from 'swiper'
import { FreeMode, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import './Reccoms.css'

class Reccoms {
  constructor () {

  }

  static initSwiper (wrapper) {
    if (!(wrapper instanceof HTMLElement)) return

    new Swiper(wrapper.querySelector('.swiper'), {
      modules: [FreeMode, Navigation],
      spaceBetween: 35,
      slidesPerView: 2,
      freeMode: false,
      breakpoints: {
        320: { slidesPerView: 1.75, spaceBetween: 10, speed: 600, freeMode: true },
        425: { slidesPerView: 2.3, spaceBetween: 10, speed: 600, freeMode: true },
        768: { slidesPerView: 4, spaceBetween: 35 },
        1024: { slidesPerView: 5 },
        1366: { slidesPerView: 6 },
        1900: { slidesPerView: 8 }
      },
      navigation: {
        nextEl: wrapper.querySelector('.swiper-button-next-recommend'),
        prevEl: wrapper.querySelector('.swiper-button-prev-recommend')
      }
    })
  }
}

export default Reccoms